var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-remove-node-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-remove-node-modal",
              attrs: {
                role: "alertdialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-remove-node-title",
                "aria-describedby": "wkb-remove-node-desc",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("header", { staticClass: "wkb-remove-node-head" }, [
                _c("h2", { attrs: { id: "wkb-remove-node-title" } }, [
                  _vm._v("Remove node"),
                ]),
                _c(
                  "p",
                  {
                    staticClass: "wkb-remove-node-desc",
                    attrs: { id: "wkb-remove-node-desc" },
                  },
                  [
                    _vm._v(" Remove "),
                    _c("strong", [_vm._v(_vm._s(_vm.nodeLabel))]),
                    _vm._v(
                      " from the graph? All edges connected to this node will be removed as well. "
                    ),
                    _vm.edgeCount > 0
                      ? _c(
                          "span",
                          { staticClass: "wkb-remove-node-edge-count" },
                          [_vm._v(" " + _vm._s(_vm.edgeCountSummary) + " ")]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _c("div", { staticClass: "wkb-remove-node-actions" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "wkb-remove-node-btn wkb-remove-node-btn-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "button",
                  {
                    staticClass:
                      "wkb-remove-node-btn wkb-remove-node-btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("confirm")
                      },
                    },
                  },
                  [_vm._v(" Confirm ")]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }